import {gql} from 'apollo-angular';

export const getRoomsListQuery  = gql`
    query jeopardyActiveGames(
        $order: [JeopardyGameSortInput!],
        $where: JeopardyGameFilterInput
    ) {
    rooms:jeopardyActiveGames(
        order: $order, 
        where: $where
    ) {
        gameId
        multiplayer
        players
        roomName
        private
        active
        startDateTime
        endDateTime
        jeopardyUsers {
            userId
            host
            name
            avatar
            connected
            deviceDetected
            deviceIdentifier
            language
            location
        }
      }
    }
`;

export const getRoomNamesQuery  = gql`
    query jeopardyRooms(
        $order: [JeopardyRoomSortInput!],
        $where: JeopardyRoomFilterInput,
    ) {
    rooms:jeopardyRooms(
        where: $where,
        order: $order,
    ) {
        roomName
        countryId
      }
    }
`;